import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-text-questiontype',
  templateUrl: './text.questiontype.component.html'
})
export class TextQuestiontypeComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;
  @Input() questioninitmixin:any;
  value:'';
  formSegment:FormGroup;

  public getValue():object {
    var result={};
    if(!this.disabled) {
      var val=String(this.formSegment.value['item'] || '');
      result[this.questionid]=val.trim();
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  isValid():boolean {
    var err;
    if(this.disabled) {
      return true;
    }
    err=this.formSegment.controls['item'].errors;
    if(!!err) {
      if(!this.formSegment.value['item']) {
        delete err.email;
        if (Object.keys(err).length === 0) {
          err=null;
        }
      }
    }
    return !err;
  }
  validate():boolean {
    this.formSegment.controls['item'].markAsTouched();
    return this.isValid();
  }

  get formError():string {
    var err;

    if((this.formSegment.controls['item'].dirty || this.formSegment.controls['item'].touched) && !this.isValid()) {
      err=this.formSegment.controls['item'].errors;
      if(!!err.whitespace) {
        return 'This answer is required.';
      }
      if(!!err.minlength) {
        return 'This answer must be at least '+err.minlength.requiredLength+' characters. You have entered '+err.minlength.actualLength+'.';
      }
      if(!!err.maxlength) {
        return 'This answer may be no longer than '+err.maxlength.requiredLength+' characters. You have entered '+err.maxlength.actualLength+'.';
      }
      if(!!this.formSegment.controls['item'].value && !!err.email) {
        return 'Invalid email address.';
      }
      if(!!err.pattern) {
        return 'Invalid answer format.';
      }
    }
    return '';
  }

  trimValidator(control: FormControl) {
    const isWhitespace=String(control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  ngOnInit() {
    var init={};
    var validators=[];
    if (this.required) {
      validators.push(this.trimValidator);
    }
    if(!!this.questioninitmixin) {
      if(!!this.questioninitmixin['minLength']) {
        validators.push(Validators.minLength(this.questioninitmixin['minLength']));
      }
      if(!!this.questioninitmixin['maxLength']) {
        validators.push(Validators.min(this.questioninitmixin['maxLength']));
      }
      if(!!this.questioninitmixin['email']) {
        validators.push(Validators.email);
      }
      if(!!this.questioninitmixin['pattern']) {
        validators.push(Validators.pattern(new RegExp(this.questioninitmixin['pattern'])));
      }
    }
    init['item']=new FormControl(this.value,validators);

    this.formSegment=new FormGroup(init);
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/text.questiontype.component.ts